import apiClient from "@services/api/apiClient.jsx";

/**
 * 카메라 앵글 파일 관련 API 서비스
 */
const cameraAngleFileApi = {
  /**
   * 앵글 파일 추가
   * @param {number} angleId 카메라 앵글 ID
   * @param {Object} fileData 파일 데이터
   * @returns {Promise<Object>} 추가된 파일 정보
   */
  addFile: async (angleId, fileData) => {
    try {
      const response = await apiClient.post(`/camera-angles/${angleId}/files`, fileData);
      return response.data;
    } catch (error) {
      console.error('파일 추가 실패:', error);
      throw error;
    }
  },

  /**
   * 앵글 파일 목록 조회
   * @param {number} angleId 카메라 앵글 ID
   * @returns {Promise<Array>} 파일 목록
   */
  getFiles: async (angleId) => {
    try {
      const response = await apiClient.get(`/camera-angles/${angleId}/files`);
      return response.data;
    } catch (error) {
      console.error('파일 목록 조회 실패:', error);
      throw error;
    }
  },

  /**
   * 앵글 파일 수정
   * @param {number} angleId 카메라 앵글 ID
   * @param {number} fileId 파일 ID
   * @param {Object} fileData 파일 데이터
   * @returns {Promise<Object>} 수정된 파일 정보
   */
  updateFile: async (angleId, fileId, fileData) => {
    try {
      const response = await apiClient.put(`/camera-angles/${angleId}/files/${fileId}`, fileData);
      return response.data;
    } catch (error) {
      console.error('파일 수정 실패:', error);
      throw error;
    }
  },

  /**
   * 앵글 파일 삭제
   * @param {number} angleId 카메라 앵글 ID
   * @param {number} fileId 파일 ID
   * @returns {Promise<Object>} 삭제 결과
   */
  deleteFile: async (angleId, fileId) => {
    try {
      const response = await apiClient.delete(`/camera-angles/${angleId}/files/${fileId}`);
      return response.data;
    } catch (error) {
      console.error('파일 삭제 실패:', error);
      throw error;
    }
  },

  /**
   * 앵글 파일 순서 변경
   * @param {number} angleId 카메라 앵글 ID
   * @param {Array} fileOrders 파일 순서 배열
   * @returns {Promise<Object>} 순서 변경 결과
   */
  reorderFiles: async (angleId, fileOrders) => {
    try {
      const response = await apiClient.put(`/camera-angles/${angleId}/files/reorder`, {
        fileOrders,
      });
      return response.data;
    } catch (error) {
      console.error('파일 순서 변경 실패:', error);
      throw error;
    }
  },

  /**
   * 앵글 파일 활성화/비활성화 토글
   * @param {number} angleId 카메라 앵글 ID
   * @param {number} fileId 파일 ID
   * @returns {Promise<Object>} 토글된 파일 정보
   */
  toggleFileActive: async (angleId, fileId) => {
    try {
      const response = await apiClient.put(`/camera-angles/${angleId}/files/${fileId}/toggle-active`);
      return response.data;
    } catch (error) {
      console.error('파일 상태 변경 실패:', error);
      throw error;
    }
  },

  /**
   * 파일 업로드 (공통 파일 업로드 API 사용)
   * @param {File} file 업로드할 파일
   * @returns {Promise<Object>} 업로드 결과
   */
  uploadFile: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await apiClient.post('/common/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      console.error('파일 업로드 실패:', error);
      throw error;
    }
  },

  // 테스트용 메서드들
  test: {
    getAllFiles: async () => {
      try {
        const response = await apiClient.get('/test/camera-angle-files/all');
        return response.data;
      } catch (error) {
        console.error('테스트 실패:', error);
        throw error;
      }
    },

    getFileCount: async () => {
      try {
        const response = await apiClient.get('/test/camera-angle-files/count');
        return response.data;
      } catch (error) {
        console.error('테스트 실패:', error);
        throw error;
      }
    },

    getFilesByAngle: async (angleId) => {
      try {
        const response = await apiClient.get(`/test/camera-angle-files/by-angle/${angleId}`);
        return response.data;
      } catch (error) {
        console.error('테스트 실패:', error);
        throw error;
      }
    }
  }
};

export default cameraAngleFileApi;